import React, { createContext, useContext } from 'react';

export const MessageContext = createContext(null);

export const useMessageContext = () => {
    const context = useContext(MessageContext);
    if (!context) {
        throw new Error('The context must be used inside <MessageContext> Provider.');
    }
    return context;
};

/**
 * Marks an element as part of the message's controls cluster (mobile action
 * panel or desktop dropdown). A blur/focus transition that stays within an
 * element carrying this attribute should not collapse the panel.
 */
export const CONTROLS_PANEL_ATTR = 'data-controls-panel';
const CONTROLS_PANEL_SELECTOR = `[${CONTROLS_PANEL_ATTR}="true"]`;

export const isRelatedTargetInsideControlsPanel = event =>
    Boolean(event.relatedTarget?.closest?.(CONTROLS_PANEL_SELECTOR));
